export const FINGERTIP_ENTER_THRESHOLD = 0.32;
export const FAST_SIGN_THRESHOLD = 0.16;
export const FAST_TRAVEL_THRESHOLD = 0.5;

export function createFlipState() {
  return {
    currentZone: "neutral",
    fastExtreme: 0,
    fastSide: null,
    lastCountAt: -Infinity,
    lastCountReason: null,
    lastExtremeLabel: null,
    lastSample: null,
    lastSeenAt: 0,
  };
}

export function updateFingertipFlipState(flip, hand, now, countPoint) {
  const sample = getFingertipDirectionSample(hand);
  flip.lastSample = sample;
  flip.lastSeenAt = now;

  if (updateFastCrossing(flip, sample, now, countPoint)) {
    return true;
  }

  if (!sample.label) {
    flip.currentZone = "neutral";
    return false;
  }

  flip.currentZone = sample.label;

  if (!flip.lastExtremeLabel) {
    flip.lastExtremeLabel = sample.label;
    return false;
  }

  if (sample.label === flip.lastExtremeLabel) {
    return false;
  }

  flip.lastExtremeLabel = sample.label;

  return countPoint(now, "zone");
}

export function getFingertipDirectionSample(hand) {
  if (!hand) {
    return { label: null, name: "fingertips", oppositeName: "the other way", strength: 0 };
  }

  const vector = hand.fingertipVector;
  const vectorLength = Math.hypot(vector.x, vector.y);
  const directionValue = vector.x / Math.max(vectorLength, 0.001);
  const horizontalStrength = Math.abs(directionValue);
  const longEnough = vectorLength >= clamp(hand.handSize * 0.18, 0.018, 0.06);
  const horizontalEnough = horizontalStrength >= FINGERTIP_ENTER_THRESHOLD;

  if (longEnough && horizontalEnough) {
    const label = directionValue < 0 ? "left" : "right";
    return {
      label,
      name: label,
      oppositeName: label === "left" ? "right" : "left",
      strength: horizontalStrength,
      value: directionValue,
      vectorLength,
      zone: label,
    };
  }

  return {
    label: null,
    name: "fingertips",
    oppositeName: "left or right",
    strength: horizontalStrength,
    value: directionValue,
    vectorLength,
    zone: "neutral",
  };
}

function updateFastCrossing(flip, sample, now, countPoint) {
  const value = sample?.value;

  if (value == null || sample.vectorLength < 0.018) {
    return false;
  }

  const side = value <= -FAST_SIGN_THRESHOLD ? "left" : value >= FAST_SIGN_THRESHOLD ? "right" : null;

  if (!side) {
    return false;
  }

  if (!flip.fastSide) {
    flip.fastSide = side;
    flip.fastExtreme = value;
    return false;
  }

  if (side === flip.fastSide) {
    if ((side === "left" && value < flip.fastExtreme) || (side === "right" && value > flip.fastExtreme)) {
      flip.fastExtreme = value;
    }

    return false;
  }

  const travel = Math.abs(value - flip.fastExtreme);
  const strongTransition = travel >= FAST_TRAVEL_THRESHOLD || sample.strength >= FINGERTIP_ENTER_THRESHOLD;
  flip.fastSide = side;
  flip.fastExtreme = value;

  if (!strongTransition) {
    return false;
  }

  flip.lastExtremeLabel = side;
  return countPoint(now, travel >= FAST_TRAVEL_THRESHOLD ? "fast" : "zone");
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}
